document.querySelectorAll('.live-cams-block').forEach(block => {
  const select = block.querySelector('select');
  const watchLive = block.querySelector('[data-watch-live]');
  if (!select || !watchLive) return;

  const sync = () => watchLive.href = select.value;
  select.addEventListener('change', sync);
  sync();
});
